<template>
  <div @click="clickEachGameItem" class="eachIconParent" :style='{
            boxShadow:eachRowCount>=3?(isFromSecondLobby&&HNewGameUIConfig.newGameUIType === 3 ?"0 4px 6px -4px rgba(255, 255, 255, 0.38)":"0 4px 6px -4px rgba(0, 0, 0, 0.38)"):"0 4px 12px rgba(0, 0, 0, 0)",
            borderBottomLeftRadius:eachRowCount>=3?"10px":"0",
            borderBottomRightRadius:eachRowCount>=3?"10px":"0",
          }'>
    <div style="position: relative;">
      <HCacheImage v-if="eachRowCount>2" :src="itemInfo['Icon']"
                   :width="eachImgWidth+'px'"
                   :height="eachImgWidth+(HNewGameUIConfig.newGameUIType === 4 && !isHaveTitle && isFromHome?eachImgWidth/8:0)+'px'"
                   radiusTop="10px"/>
      <HCacheImage v-if="eachRowCount<=2" :src="itemInfo['Icon']" :width="eachImgWidth+'px'" radiusTop="10px"/>
      <div v-if="(eachRowCount>=3 && itemInfo['IconLogo']!=='') && (HNewGameUIConfig.newGameUIType !== 4 || !isFromHome || HNewGameUIConfig.newGameUIType === 4 && isHaveTitle)" class="floating-icon">
        <HCacheImage :src="itemInfo['IconLogo']" height="10px"/>
      </div>
      <div @click="clickFavorite" v-if="itemInfo['FavoriteState'] === 0 || itemInfo['FavoriteState'] === 1"
           style="width:25px;height:25px;position:absolute;top:0;right:0;background-color: white;border-bottom-left-radius: 10px;align-items: center;display: flex;justify-content: center;">
        <img :src="favoriteCallback?(itemInfo['FavoriteState']===1?iconLike:iconUnLike):(isLike?iconLike:iconUnLike)" style="width: 80%;height:80%;" alt="">
      </div>
      <div v-if="itemInfo['Status'] === 1"
           style="display:flex;align-items: center;justify-content:center;width:100%;background-color:#000a;height:100%;border-top-left-radius:10px;border-top-right-radius:10px;position: absolute;top:0;left:0;">
        <div :style="hcf.getTextStyle({
                  color:'white',addSize:1,fontWeight:'bold'
              })">
          维护中
        </div>
      </div>
    </div>
    <div v-if="eachRowCount>=3 && (HNewGameUIConfig.newGameUIType !== 4 || !isFromHome || HNewGameUIConfig.newGameUIType === 4 && isHaveTitle)" :style="hcf.getTextStyle({
      color:isFromSecondLobby&&HNewGameUIConfig.newGameUIType === 3 ? 'white':'black',addSize:-1
    })">
      {{ itemInfo['Title'].length >= 7 ? itemInfo['Title'].slice(0, 5) + "..." : itemInfo["Title"] }}
    </div>
  </div>
</template>


<script setup>
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {showToast} from "vant";

  const props = defineProps(["isFromSecondLobby","itemInfo", "eachRowCount", "eachImgWidth", "favoriteCallback","isHaveTitle","isFromHome"]);
  const user = useUserStore();
  const http = useHHttp();
  const clickModal = useClickModal();
  import iconLike from "@/assets/icons/common/like.png";
  import iconUnLike from "@/assets/icons/common/unlike.png";
  import HCacheImage from "@/components/utils/HCacheImage.vue";
  import {useClickModal} from "@/hooks/useClickModal.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  const isLike  = ref(props.itemInfo["FavoriteState"]);

  function clickFavorite(event) {
    event.stopPropagation();
    http.request(
        (props.favoriteCallback?(props.itemInfo['FavoriteState'] === 0):(isLike.value === 0))
            ? "/qp/game/add-favorite"
            : "/qp/game/del-favorite", () => {

          if (props.favoriteCallback) {
            props.favoriteCallback();
          }else{
            isLike.value = !isLike.value;
          }
        }, {
          params: {
            "UserId": user.userId,
            "GameId": props.itemInfo["ClickParam"]
          }
        });
  }

  function clickEachGameItem() {
    if (props.itemInfo["Status"] === 1) {
      showToast("游戏维护中,请稍后再来吧");
    } else {
      if(props.itemInfo["ClickType"] === 2){
        clickModal.onClick(props.itemInfo);
      }else{
        clickModal.onClick({
              ClickType: props.itemInfo["ClickType"],
              ClickParam: {
                "name": props.itemInfo["Title"],
                "paras": props.itemInfo["ClickParam"],
                "leaveArgument": props.itemInfo["leaveArgument"],
              }
            }
        );
      }
    }
  }

</script>


<style scoped>

  .eachIconParent {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .floating-icon {
    position: absolute;
    bottom: 6px;
    right: 3px;
    width: 26px;
    background-color: white;
    border-radius: 4px;
    display: flex;
    padding: 2px 2px;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
</style>
